module.exports = __webpack_public_path__ + "static/gallery1-30c936bdb63189c78a083c17445ca1c7.jpeg";